import React from "react";

const FlightDeals = () => {
  const deals = [
    {
      dest: "Paris",
      origin: "New York",
      price: "$345",
      img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=600&q=80",
      tag: "Hot Deal",
    },
    {
      dest: "Tokyo",
      origin: "San Francisco",
      price: "$499",
      img: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=600&q=80",
      tag: "Weekend Special",
    },
    {
      dest: "Rome",
      origin: "Chicago",
      price: "$389",
      img: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=600&q=80",
      tag: "Last Minute",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 font-sans pt-12 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-end mb-10 gap-4">
          <div>
            <h1 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight mb-2">
              Exclusive Flight Deals
            </h1>
            <p className="text-slate-500 font-medium">
              Grab these limited-time offers before they're gone.
            </p>
          </div>
          <select className="bg-white border border-slate-200 text-slate-700 font-bold px-4 py-2 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none">
            <option>All Destinations</option>
            <option>Europe</option>
            <option>Asia</option>
            <option>Domestic</option>
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {deals.map((deal, idx) => (
            <div
              key={idx}
              className="group bg-white rounded-3xl overflow-hidden shadow-sm border border-slate-100 cursor-pointer hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={deal.img}
                  alt={deal.dest}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                <div className="absolute top-4 left-4 bg-orange-500 text-white text-[11px] font-black uppercase tracking-wider px-3 py-1 rounded-full shadow-lg">
                  {deal.tag}
                </div>
              </div>
              <div className="p-6">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">
                  {deal.origin} to
                </div>
                <div className="flex justify-between items-end">
                  <h3 className="text-2xl font-black text-slate-900">
                    {deal.dest}
                  </h3>
                  <div className="text-right">
                    <div className="text-[10px] text-slate-500 font-bold uppercase mb-0.5">
                      Starting at
                    </div>
                    <div className="text-2xl font-black text-blue-600 leading-none">
                      {deal.price}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FlightDeals;
